// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ea70e7ead0ac3a453c9be305e7edff39" + ".js";
};